import React, {useState} from 'react'
import { useForm } from 'react-hook-form'
import { Grid, TextField, InputAdornment, useMediaQuery, Divider } from '@material-ui/core'
import PhoneIcon from '@material-ui/icons/Phone';
import InfoIcon from '@material-ui/icons/Info';
import PersonIcon from '@material-ui/icons/Person';
import { ClaimContextStore, ACTIONS } from '../../context/ClaimContext';
import SkywatchDropzone from '../Core/SkywatchDropzone';
import FlexView from 'react-flexview/lib';
import AirplanemodeActiveIcon from '@material-ui/icons/AirplanemodeActive';
import DescriptionIcon from '@material-ui/icons/Description';
import { BackButton } from '../Core/Buttons/BackButton';
import claimsApi from '../../api/claims.api';
import LocalizationService from '../../services/LocalizationService';
import { ClaimIncidentDocPopover } from '../Core/Popover/ClaimIncidentDocPopover';
import { ClaimFlightLogPopover } from '../Core/Popover/ClaimFlightLogPopover';
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import { GreenButton } from '../Core/Buttons/GreenButton';
import { awaitWithLoading } from '../../services/utils';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { PHONE_NUMBER_REGEX } from '../../Constants';
import { SkywatchDialog } from "../PopUps/SkywatchDialog"
import NewFillButton from "../Core/NewFillButton"

export const ClaimInfoFilesUploadStep = () => {
    const claimContext = React.useContext(ClaimContextStore)
    const isMobileByWidth = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const { register, getValues, triggerValidation, control, errors, watch } = useForm({defaultValues: claimContext.claim_files_info, mode: 'onChange'})
    const [continueError, setContinueError] = React.useState()
    const flightLogsRef = React.useRef()
    const incidentPhotosRef = React.useRef()
    const part107Ref = React.useRef()
    const aircraftCertificateRef = React.useRef()
    const [incidectDocError, setIncidectDocError] = React.useState('')
    const [showEmptyFlightLogsPopup, setShowEmptyFlightLogsPopup] = useState(false)

    const openFlightLogFAQ = () => window.open("https://faq.skywatch.ai/hc/en-us/articles/360025271611", "_blank")

    const checkDocumentsLength = () => {
        if(incidentPhotosRef.current.getFiles().length == 0) {
            setIncidectDocError('Required')
            return false
        }
        else {
            setIncidectDocError('')
        }
        return true
    }

    const isFlightLogsEmpty = () => {
        if(flightLogsRef.current.getFiles().length == 0 && !showEmptyFlightLogsPopup){
            setShowEmptyFlightLogsPopup(true)
            return true
        }
        return false 
    }

    const onContinue = async () => {
        let valid = await triggerValidation()

        if(!checkDocumentsLength()) return
        
        if(!valid) return

        let form = getValues()

        if(isFlightLogsEmpty()) return
        
        claimContext.dispatch(ACTIONS.SET_FILES_INFO, form)
        let res = await awaitWithLoading(claimsApi.submitClaim(claimContext.selected_policy.insuranceId,
            claimContext.date_happen, claimContext.claim_incident_info.location, form.incident_description,
            claimContext.claim_incident_info.claim_reason, claimContext.claim_incident_info.claim_type,
            form.phone_number, form.witnesses, incidentPhotosRef.current.getFiles(), flightLogsRef.current.getFiles(),
            claimContext.claim_hull_info.drones, claimContext.claim_hull_info.equipment,
             part107Ref.current.getFiles(),
             aircraftCertificateRef.current.getFiles(), form.pilot_command))
        
        if(res.ok) {
            EventEmitterService.dispatch(EventKey.CLAIM_FILES_INFO_FINISHED)
            claimContext.clearStorage()
        }
        else 
            EventEmitterService.dispatch(EventKey.ShowError, res)
    }

    return (<>
        <br />
        <div className="text-title blue bold">Claim Info</div>
        {!isMobileByWidth && <Divider />}
        {/* <div className="text-body gray">Select the item(s) you wish to make a claim for</div> */}
        <br />
        <Grid container spacing={3}>
            <Grid item sm={12} xs={12} md={6}>
                <TextField
                    fullWidth
                    error={!!errors.phone_number}
                    helperText={!!errors.phone_number && 'not a valid phone number'}
                    variant="outlined" label="Phone Number" 
                    placeholder="Provide a number for contact" 
                    name={`phone_number`} 
                    InputProps={{startAdornment: <InputAdornment position="start"><PhoneIcon className="lightgrayblue" /></InputAdornment>}}
                    inputRef={register({required: true, pattern: PHONE_NUMBER_REGEX})} />
                <TextField
                    fullWidth
                    className="margin-top-medium"
                    error={!!errors.incident_description}
                    helperText={!!errors.incident_description && errors.incident_description.type}
                    variant="outlined" label="Incident Description" 
                    placeholder="Provide as much detail about the incident as possible" 
                    multiline
                    rows={5}
                    InputProps={{startAdornment: <InputAdornment position="start"><InfoIcon className="lightgrayblue" /></InputAdornment>}}
                    name={`incident_description`} 
                    inputRef={register({required: true})} />
                <TextField
                    fullWidth
                    className="margin-top-medium"
                    error={!!errors.witnesses}
                    helperText={!!errors.witnesses && errors.witnesses.type}
                    variant="outlined" label="Witnesses Info" 
                    placeholder="Provide name and contact info for any witnesses on scence incident" 
                    multiline
                    rows={3}
                    InputProps={{startAdornment: <InputAdornment position="start"><PersonIcon className="lightgrayblue" /></InputAdornment>}}
                    name={`witnesses`} 
                    inputRef={register({required: true})} />
                <TextField
                    fullWidth
                    className="margin-top-medium"
                    error={!!errors.pilot_command}
                    helperText={!!errors.pilot_command}
                    variant="outlined" label="Pilot in command" 
                    placeholder="Provide the full name of the pilot in command" 
                    multiline
                    rows={3}
                    InputProps={{startAdornment: <InputAdornment position="start"><PersonIcon className="lightgrayblue" /></InputAdornment>}}
                    name={`pilot_command`} 
                    inputRef={register({required: true})} />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
                <FlexView vAlignContent={'center'}>
                    <div className="full-width margin-right-6">
                        <SkywatchDropzone 
                            ref={flightLogsRef}
                            accept={[".txt", ".csv", ".json", ".log"]}
                            placeholder={<FlexView vAlignContent={'center'}>
                                <AirplanemodeActiveIcon className="lightgrayblue margin-right-6" />
                                <div className="text-body lightgrayblue"><span className="blue underline">Upload</span> or drag & drop your flight logs (if available)</div>
                            </FlexView>} />
                    </div>
                    <div onClick={openFlightLogFAQ}><ClaimFlightLogPopover /></div>
                </FlexView>
                <br />
                <br />
                <FlexView vAlignContent={'center'}>
                    <div className="full-width margin-right-6">
                        <SkywatchDropzone 
                        error={incidectDocError}
                        ref={incidentPhotosRef}
                        accept="image/*"
                        placeholder={<FlexView vAlignContent={'center'}>
                            <DescriptionIcon className="lightgrayblue margin-right-6" />
                            <div className="text-body lightgrayblue"><span className="blue underline">Upload</span> or drag & drop any relevant incident documentation</div>
                        </FlexView>} />
                    </div>
                    <ClaimIncidentDocPopover />
                </FlexView>
                <br />
                <br />
                <SkywatchDropzone
                  ref={part107Ref}
                  accept={["application/*", "image/*", "application/msword", "application/pdf"]}
                  placeholder={<FlexView vAlignContent={'center'}>
                    <DescriptionIcon className="lightgrayblue margin-right-6" />
                    <div className="text-body lightgrayblue"><span className="blue underline">Upload</span> or drag & drop {LocalizationService.STRINGS.part107description}
                    certificate issued by the FAA</div>
                </FlexView>} />
                <br />
                <br />
                <SkywatchDropzone
                  ref={aircraftCertificateRef}
                  accept={["application/*", "image/*", "application/msword", "application/pdf"]}
                  placeholder={<FlexView vAlignContent={'center'}>
                    <DescriptionIcon className="lightgrayblue margin-right-6" />
                    <div className="text-body lightgrayblue"><span className="blue underline">Upload</span> or drag & drop {LocalizationService.STRINGS.aircraftRegistrationCertificate}</div>
                </FlexView>} />
            </Grid>
        </Grid>
        <div className="text-body red margin-top-6">{continueError}</div>
        <FlexView className="margin-top-basic">
            <BackButton />
            <GreenButton onClick={onContinue}>Submit Your Claim</GreenButton>
        </FlexView>
        <SkywatchDialog 
            open={showEmptyFlightLogsPopup} 
            maxWidth={'sm'}
            includeCancelButton={true}
            closeDialog={() => setShowEmptyFlightLogsPopup(false)}
        >
                <div className="blue bold text-title textcenter margin-bottom-basic">Flight Log Submission Reminder</div>
                <div className="textleft margin-left-basic margin-right-basic">To ensure the smooth handling of your claim, our team requires flight logs or alternative proof of the incident's occurrence time (except in cases of theft).
                <br></br>While you can proceed with your application now, please note that these documents may be requested at a later stage for claim verification. </div>

                <Grid container justifyContent="center">
                    <NewFillButton onClick={() => onContinue()}>Continue</NewFillButton>
                    
                </Grid>
            
        </SkywatchDialog>
    </>)
}